import { render } from "./StatisticsView.vue?vue&type=template&id=c6c13656&scoped=true"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"

import "./StatisticsView.vue?vue&type=style&index=0&id=c6c13656&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c13656"]])

export default __exports__